
import { ElementAttribute } from "../../dom-tools/ElementAttribute";
import { OnClick } from "../../dom-tools/EventListeners";
import { APIFunctionNames, COOKIE_DELETE_ALL } from "../api/APIFunctionName";
import { APIRequest } from "../api/APIRequest";
import { APIInputData } from "../api/APIInputData";
import { InputData } from "../input/InputData";
import { PHPResponse } from "../PHPResponse";
import { PHPContext } from "../PHPContext";

export class CookieDeleteAllRequest extends APIRequest<COOKIE_DELETE_ALL,APIInputData,PHPResponse>
{
  static readonly cookieDeleteAll = new ElementAttribute( "cookie-delete-all" );
  constructor(){ super( APIFunctionNames.COOKIE_DELETE_ALL ); }

  static applyOnDocument( context:PHPContext, callback:()=>void = null )
  {
    this.cookieDeleteAll.forEachInDoc(
      ( element )=>
      {
        OnClick.add( element as HTMLElement, 
          async ( e )=>
          {
            let request = new CookieDeleteAllRequest();
            await request.call( context, new APIInputData() );

            if ( callback ){ callback(); }
          }
        )
      }
    )
  }
}